<template>
  <div id="app">
    <router-view />
  </div>
</template>


<style src="./style.scss" lang="scss"></style>

<script>

export default {
  name: "app",
  metaInfo: {
    title: "Eines AS",
    titleTemplate: "%s - Eines AS",
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    userEmail: function () {
      return this.$store.getters.userEmail;
    },
  },
  watch: {
    $isOnline(status) {
      console.log('App: Network status changed to:', status ? 'ONLINE' : 'OFFLINE');
    }
  },
  methods: {
    updated() {
      // Remove loading state
      //setTimeout(() => document.body.classList.remove("app-loading"), 1);
    },
    getGeolocation() {
      this.$getLocation({
        enableHighAccuracy: true, //defaults to false
        timeout: Infinity, //defaults to Infinity
        maximumAge: 0, //defaults to 0
      }).then((coordinates) => {
        this.geolocation = coordinates;
      });
    },
  },
  created: function () {
    this.updated();
    console.log('App created. Initial network status:', this.$isOnline ? 'ONLINE' : 'OFFLINE');
  },
};
</script>

<style lang="css">
.body {
  background: #fdfdfd;
}

.leaflet-control-attribution {
    display: none;
}

/* Link style */
a {
  color: #801529;
  text-decoration: none;
}

a:hover {
  color: #9e1b33;
  text-decoration: underline;
}

</style>
